var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSymbolRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    height: 40,
    width: 40,
    fill: "#da0b1d",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "rotate(90deg)"
    },
    stroke: "#da0b1d",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.048
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M12 3L19 20L12 17L5 20L12 3Z",
    fill: "#da0b1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 20L12 3L5 20L12 17L19 20Z",
    stroke: "#da0b1d",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSymbolRed);
export default __webpack_public_path__ + "static/media/arrow-symbol-red.286976033645558c9695458319a3137a.svg";
export { ForwardRef as ReactComponent };